/** @format */

export const actionTypes = {
  AUTH_SOCIAL_REQUEST: 'auth/AUTH_SOCIAL_REQUEST',
  AUTH_SOCIAL_SUCCESS: 'auth/AUTH_SOCIAL_SUCCESS',
  AUTH_SOCIAL_ERROR: 'auth/AUTH_SOCIAL_ERROR',

  SIGN_UP_REQUEST: 'auth/SIGN_UP_REQUEST',
  SIGN_UP_SUCCESS: 'auth/SIGN_UP_SUCCESS',
  SIGN_UP_ERROR: 'auth/SIGN_UP_ERROR',

  SIGN_IN_REQUEST: 'auth/SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS: 'auth/SIGN_IN_SUCCESS',
  SIGN_IN_ERROR: 'auth/SIGN_IN_ERROR',

  SIGN_OUT_REQUEST: 'auth/SIGN_OUT_REQUEST',
  SIGN_OUT_SUCCESS: 'auth/SIGN_OUT_SUCCESS',
  SIGN_OUT_ERROR: 'auth/SIGN_OUT_ERROR',

  FORGOT_PASSWORD_REQUEST: 'auth/FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'auth/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR: 'auth/FORGOT_PASSWORD_ERROR',
}

export const authSocial = {
  request: () => ({
    type: actionTypes.AUTH_SOCIAL_REQUEST,
  }),
  success: (payload) => ({
    type: actionTypes.AUTH_SOCIAL_SUCCESS,
    payload,
  }),
  error: (payload) => ({
    type: actionTypes.AUTH_SOCIAL_ERROR,
    payload,
  }),
}

export const signUp = {
  request: () => ({
    type: actionTypes.SIGN_UP_REQUEST,
  }),
  success: (payload) => ({
    type: actionTypes.SIGN_UP_SUCCESS,
    payload,
  }),
  error: (payload) => ({
    type: actionTypes.SIGN_UP_ERROR,
    payload,
  }),
}

export const signIn = {
  request: () => ({
    type: actionTypes.SIGN_IN_REQUEST,
  }),
  success: (payload) => ({
    type: actionTypes.SIGN_IN_SUCCESS,
    payload,
  }),
  error: (payload) => ({
    type: actionTypes.SIGN_IN_ERROR,
    payload,
  }),
}

export const signOut = {
  request: () => ({
    type: actionTypes.SIGN_OUT_REQUEST,
  }),
  success: (payload) => ({
    type: actionTypes.SIGN_OUT_SUCCESS,
    payload,
  }),
  error: (payload) => ({
    type: actionTypes.SIGN_OUT_ERROR,
    payload,
  }),
}

export const forgot = {
  request: () => ({
    type: actionTypes.FORGOT_PASSWORD_REQUEST,
  }),
  success: (payload) => ({
    type: actionTypes.FORGOT_PASSWORD_SUCCESS,
    payload,
  }),
  error: (payload) => ({
    type: actionTypes.FORGOT_PASSWORD_ERROR,
    payload,
  }),
}
